import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/Layout";
import { ErrorPage } from "./pages/errorpage/ErrorPage";
import { Home } from "./pages/home/Home";
import { Forum } from "./pages/forum/Forum";
import { Discussion } from "./pages/forum/gamediscussion/discussion/Discussion";
import { Help } from "./pages/forum/gamediscussion/help/Help"
import { Lfg } from "./pages/forum/gamediscussion/lfg/Lfg";
import { News } from "./pages/forum/newsinformation/news/News";
import { Updates } from "./pages/forum/newsinformation/updates/Updates";
import { Gamesupport } from "./pages/forum/support/gamesupport/Gamesupport";
import { Websupport } from "./pages/forum/support/websupport/Websupport";
import { Postdetail } from "./pages/postdetail/Postdetail";
import { Register } from "./pages/register/Register";
import { Login } from "./pages/login/Login";
import { Userprofile } from "./pages/userprofile/Userprofile";
import { Players } from "./pages/players/Players";
import { Createpost } from "./pages/createpost/Createpost";
import { Editpost } from "./pages/editpost/Editpost";
import { Deletepost } from "./pages/deletepost/Deletepost";
import { Categoryposts } from "./pages/categoryposts/Categoryposts";
import { Playerposts } from "./pages/playerposts/Playerposts";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Logout } from "./pages/logout/Logout";
import UserProvider from "./context/userContext";
import About from "./pages/about/About";
import { disableReactDevTools } from '@fvilers/disable-react-devtools'

if(process.env.NODE_ENV === 'production') disableReactDevTools ();


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <UserProvider>
        <Layout />
      </UserProvider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },


      {
        path: "posts/:id",
        element: <Postdetail />,
      },

      {
        path: "forum/support/websupport/:id",
        element: <Postdetail />,
      },
      {
        path: "forum/support/gamesupport/:id",
        element: <Postdetail />,
      },     
      {
        path: "forum/newsinformation/news/:id",
        element: <Postdetail />,
      },
      {
        path: "forum/newsinformation/update/:id",
        element: <Postdetail />,
      },
      {
        path: "forum/gamediscussion/discussion/:id",
        element: <Postdetail />,
      },
      {
        path: "forum/gamediscussion/help:id",
        element: <Postdetail />,
      },
      {
        path: "forum/gamediscussion/lfg/:id",
        element: <Postdetail />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "profile/:id",
        element: <Userprofile />,
      },
      {
        path: "forum",
        element: <Forum />,
      },
      {
        path: "forum/support/websupport",
        element: <Websupport />,
      },
      {
        path: "forum/support/gamesupport",
        element: <Gamesupport />,
      },
      {
        path: "forum/newsinformation/news",
        element: <News />,
      },
      {
        path: "forum/newsinformation/updates",
        element: <Updates />,
      },
      {
        path: "forum/gamediscussion/discussion",
        element: <Discussion />,
      },
      {
        path: "forum/gamediscussion/help",
        element: <Help />,
      },
      {
        path: "forum/gamediscussion/lfg",
        element: <Lfg />,
      },
      {
        path: "players",
        element: <Players />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "create",
        element: <Createpost />,
      },
      {
        path: "posts/categories/:category",
        element: <Categoryposts />,
      },
      {
        path: "posts/users/:id",
        element: <Playerposts />,
      },
      {
        path: "myposts/:id",
        element: <Dashboard />,
      },
      {
        path: "posts/:id/edit",
        element: <Editpost />,
      },
      {
        path: "posts/:id/delete",
        element: <Deletepost postId={undefined} />,
      },
      {
        path: "logout",
        element: <Logout />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);
reportWebVitals();
